import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Van Belle Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center justify-center min-h-screen bg-gradient-to-b from-yellow-50 via-amber-100 to-amber-200">
          <div className="text-center max-w-md mx-auto p-8">
            <h1 className="text-4xl font-bickham-script-pro text-yellow-900 mb-4">Van Belle</h1>
            <h2 className="text-xl font-semibold text-yellow-800 mb-4">Oops! Something went wrong</h2>
            <p className="text-yellow-700 mb-6">
              We're sorry for the inconvenience. Please refresh the page or contact us directly.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => window.location.reload()}
                className="px-6 py-3 bg-yellow-900 text-yellow-100 rounded-full hover:bg-yellow-800 transition"
              >
                Refresh Page
              </button>
              <a
                href="https://wa.me/96176919011"
                target="_blank"
                rel="noopener noreferrer"
                className="px-6 py-3 border border-yellow-900 text-yellow-900 rounded-full hover:bg-yellow-100 transition"
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;